import { ADVERTISING_AGENCY_ITEM_TYPES } from '../lib/constants';
import { turnToMonth } from '../lib/helpers';
// ---- internal imports ----

class Tradeshow {
	constructor(id, title, price, earlyBird, startInMonth, benefit) {
		this.id = id;
		this.title = title;
		this.price = price;
		this.earlyBird = earlyBird;
		this.startInMonth = startInMonth;
		this.benefit = benefit;
		this.type = ADVERTISING_AGENCY_ITEM_TYPES.TRADESHOW;
	}

	getFormattedStartInDate() {
		return `16 ${turnToMonth(this.startInMonth)}`;
	}

	toPlainObj() {
		return {
			id: this.id,
			title: this.title,
			earlyBird: this.earlyBird,
			price: this.price,
			startInMonth: this.startInMonth,
			formattedStartInDate: this.getFormattedStartInDate(),
			benefit: this.benefit,
			type: this.type
		};
	}
}

function TradeshowBuilder() {
	return {
		withId: function (id) {
			this.id = id;
			return this;
		},
		withTitle: function (title) {
			this.title = title;
			return this;
		},
		withPrice: function (price) {
			this.price = price;
			return this;
		},
		withEarlyBird: function (price, availableBeforeMonth) {
			this.earlyBird = { price, availableBeforeMonth };
			return this;
		},
		withStartInMonth: function (startInMonth) {
			this.startInMonth = startInMonth;
			return this;
		},
		withBenefit: function (benefit) {
			this.benefit = benefit;
			return this;
		},
		build: function () {
			return new Tradeshow(this.id,
				this.title,
				this.price,
				this.earlyBird,
				this.startInMonth,
				this.benefit
			);
		}
	};
}

export default function CreateTradeshowModel(tradeshow) {
	/* eslint-disable camelcase */
	return new TradeshowBuilder()
		.withId(tradeshow.id)
		.withTitle(tradeshow.title)
		.withPrice(tradeshow.price)
		.withEarlyBird(tradeshow.early_bird?.price, tradeshow.early_bird?.available_before_month)
		.withStartInMonth(tradeshow.start_in_month)
		.withBenefit(tradeshow.benefit)
		.build()
		.toPlainObj();
	/* eslint-enable camelcase */
}
